// extracted by mini-css-extract-plugin
export default {"side_menu_container":"styles_side_menu_container__cYaf6","side_menu_tab":"styles_side_menu_tab__0ARE8","side_menu_tab_active":"styles_side_menu_tab_active__QSEQ5"};